import { BarChart3 } from "lucide-react";

export function AnalyticsPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-8rem)] px-4 py-20">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-full bg-secondary/10 border border-secondary/20 flex items-center justify-center mx-auto mb-6">
          <BarChart3 className="w-10 h-10 text-secondary" />
        </div>
        <h1 className="font-display text-4xl font-black mb-4">
          <span className="gradient-text">Analytics</span>
        </h1>
        <p className="text-text-secondary text-base mb-8 leading-relaxed">
          On-chain analytics for Jasmy Swap — volume, TVL, fees, token performance, and
          holder distribution. Data pipeline connecting shortly.
        </p>
        <div className="grid grid-cols-3 gap-3 mb-8">
          {[
            { label: "24h Volume", value: "—" },
            { label: "Total TVL", value: "—" },
            { label: "Total Fees", value: "—" },
          ].map((s) => (
            <div key={s.label} className="p-4 bg-surface/40 border border-border rounded-button text-center">
              <div className="font-display text-xl font-bold text-text-tertiary">{s.value}</div>
              <div className="text-xs text-text-tertiary mt-1">{s.label}</div>
            </div>
          ))}
        </div>
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary/10 border border-secondary/20 text-secondary text-sm font-medium">
          <BarChart3 className="w-4 h-4" />
          Coming Soon
        </div>
      </div>
    </div>
  );
}
